import { render, staticRenderFns } from "./Pdf4.vue?vue&type=template&id=cf9d347e&scoped=true"
import script from "./Pdf4.vue?vue&type=script&lang=js"
export * from "./Pdf4.vue?vue&type=script&lang=js"
import style0 from "./Pdf4.vue?vue&type=style&index=0&id=cf9d347e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9d347e",
  null
  
)

export default component.exports